import { actionDeclarer } from '../services/actionDeclarer';

export const {
	REMOVE_ACTIVITY,
	SET_ACTIVITY_LIST,
	SET_IS_IN_SYNC,
	SET_SNOOZE_DURATIONS,
	SET_TABLE_STATE,
	UPDATE_ACTIVITY
} = actionDeclarer;

const dashboardReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case REMOVE_ACTIVITY: {
			const updatedList = state.activityList.filter( ( { id } ) => id !== payload );

			return {
				...state,
				activityList: updatedList
			};
		}

		case SET_ACTIVITY_LIST:
			return {
				...state,
				activityList: payload
			};
		case SET_IS_IN_SYNC:
			return {
				...state,
				isInSync: payload
			};
		case SET_SNOOZE_DURATIONS:
			return {
				...state,
				snoozeDurations: payload
			};
		case SET_TABLE_STATE:
			return {
				...state,
				tableState: payload( state.tableState )
			};
		case UPDATE_ACTIVITY: {
			const updatedList = state.activityList.reduce( ( acc, item ) => {
				if ( item.id === payload.id ) {
					return [
						...acc,
						payload
					];
				}

				return [
					...acc,
					item
				];
			}, [] );

			return {
				...state,
				activityList: updatedList
			};
		}

		default:
			return state;
	}
};

export default dashboardReducer;
